import { render, staticRenderFns } from "./CookieLayer.vue?vue&type=template&id=6f879d27&scoped=true&"
import script from "./CookieLayer.vue?vue&type=script&lang=js&"
export * from "./CookieLayer.vue?vue&type=script&lang=js&"
import style0 from "./CookieLayer.vue?vue&type=style&index=0&id=6f879d27&prod&lang=scss&scoped=true&"
import style1 from "./CookieLayer.vue?vue&type=style&index=1&id=6f879d27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f879d27",
  null
  
)

export default component.exports